import {Interceptor} from '@jobseeker/common-core/lib/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp, utilServerSideDeviceDetection} from '@utils';
import {metaInfo} from '@configs';
import {HOME, ABOUTUS} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/lib/stores';
import {VersionVariants} from '@jobseeker/lotus/lib/enums/variants';
import AboutUsWidget from '@components/Static/AboutUs';
import {useDispatch} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/lib/hooks/useValidateAuth';
import {BannerInfo, HiristBanner} from '@jobseeker/lotus/lib/components';
import {BannerTick} from '@jobseeker/lotus/lib/assets/icons';
import {BaseContext} from 'next/dist/shared/lib/utils';

type AboutusProps = {
  seoConfig: object;
  isMobile: boolean;
};

const Aboutus = ({seoConfig, isMobile}: AboutusProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, ABOUTUS);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  useValidateAuth(dispatch);

  const breadcrumbElements = !isAppIimjobs
    ? []
    : [
        {
          name: 'Home',
          item: '/',
        },
        {
          name: 'About Us',
          item: ``,
        },
      ];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          {!isAppIimjobs && (
            <HiristBanner>
              <BannerInfo
                Icon={BannerTick}
                isMobile={isMobile}
                title={''}
                subTitle={`About Us`}
              />
            </HiristBanner>
          )}
          <AboutUsWidget />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: BaseContext) => {
    const seoConfig = await loadSEO(ABOUTUS);

    const {isMobile} = utilServerSideDeviceDetection(context);
    if (isMobile) {
      store.dispatch({
        type: 'AppContext/set_layout_device',
        payload: 'mobile',
      });
    }

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: ABOUTUS},
    });

    return {
      props: {
        isMobile,
        seoConfig,
      },
    };
  }
);

export default Aboutus;
